
import { Skeleton } from "@/components/ui/skeleton";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { BlogCardWireframe } from "./BlogCardWireframe";

export function BlogPostWireframe() {
  return (
    <>
      {/* Wrapper to constrain content width and match final layout */}
      <div className="max-w-7xl mx-auto">
        {/* Breadcrumb */}
        <div className="flex items-center gap-2 mb-6 text-sm text-muted-foreground">
          <Skeleton className="h-4 w-12" />
          <span>/</span>
          <Skeleton className="h-4 w-16" />
          <span>/</span>
          <Skeleton className="h-4 w-32" />
        </div>

        {/* Post Header */}
        <div className="mb-8">
          {/* Categories */}
          <div className="flex flex-wrap gap-2 mb-4">
            <Skeleton className="h-6 w-20 rounded-full" />
            <Skeleton className="h-6 w-24 rounded-full" />
          </div>
          
          {/* Title */}
          <div className="mb-6">
            <Skeleton className="h-10 w-full mb-2" />
            <Skeleton className="h-10 w-3/4" />
          </div>
          
          {/* Metadata */}
          <div className="flex flex-wrap items-center gap-4 text-sm text-muted-foreground mb-6">
            <div className="flex items-center gap-2">
              <Skeleton className="h-4 w-4 rounded-full" />
              <Skeleton className="h-4 w-24" />
            </div>
            <div className="flex items-center gap-2">
              <Skeleton className="h-4 w-4 rounded-full" />
              <Skeleton className="h-4 w-20" />
            </div>
            <div className="flex items-center gap-2">
              <Skeleton className="h-4 w-4 rounded-full" />
              <Skeleton className="h-4 w-16" />
            </div>
          </div>
        </div>

        {/* Featured Image */}
        <div className="mb-8">
          <div className="aspect-[16/9] w-full relative overflow-hidden rounded-lg">
            <Skeleton className="w-full h-full" />
          </div>
        </div>

        {/* Post Content */}
        {/* The parent div now controls the max-width, and we remove the max-width from prose */}
        <div className="prose prose-lg dark:prose-invert max-w-none mb-8">
          {/* Paragraph blocks */}
          {Array.from({ length: 8 }).map((_, index) => (
            <div key={index} className="mb-6">
              <div className="space-y-3">
                <Skeleton className="h-4 w-full" />
                <Skeleton className="h-4 w-full" />
                <Skeleton className="h-4 w-full" />
                <Skeleton className="h-4 w-2/3" />
              </div>
              
              {/* Occasional subheading */}
              {index % 3 === 0 && index > 0 && (
                <div className="mt-8 mb-4">
                  <Skeleton className="h-7 w-1/2" />
                </div>
              )}
              
              {/* Occasional image */}
              {index % 4 === 2 && (
                <div className="my-8">
                  <div className="aspect-[16/9] w-full relative overflow-hidden rounded-lg">
                    <Skeleton className="w-full h-full" />
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Tags */}
        <div className="mb-8">
          <div className="flex items-center gap-2 mb-4">
            <Skeleton className="h-5 w-12" />
          </div>
          <div className="flex flex-wrap gap-2">
            <Skeleton className="h-7 w-16 rounded-full" />
            <Skeleton className="h-7 w-20 rounded-full" />
            <Skeleton className="h-7 w-18 rounded-full" />
            <Skeleton className="h-7 w-24 rounded-full" />
            <Skeleton className="h-7 w-14 rounded-full" />
          </div>
        </div>

        {/* Share Button */}
        <div className="mb-8">
          <Skeleton className="h-10 w-32 rounded" />
        </div>
      </div>

      <Separator className="mb-10" />

      {/* Related Posts */}
      <div className="max-w-7xl mx-auto">
        <div className="mb-8">
          <Skeleton className="h-8 w-48 mb-2" />
          <Skeleton className="h-5 w-96" />
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {Array.from({ length: 3 }).map((_, index) => (
            <BlogCardWireframe key={index} />
          ))}
        </div>
      </div>
    </>
  );
}
